import React from 'react';
import { Route, useRouteMatch, Switch, useHistory } from 'react-router';
import BackOfficeInvoice from './component/BackOfficeInvoice';
import BackOfficeInvoiceList from './component/BackOfficeInvoiceList';
import BackOfficeProformaInvoiceDetails from './component/BackOfficeProformaInvoiceDetails';
import PagesHeader from '@Component/layout/PagesHeader';
import ContractDownloadInvoice from '@Modules/setting/billing/components/invoiceInfo/downloadInvoice';

function Profile() {
  const match = useRouteMatch();
  const { location } = useHistory();
  const invoiceView = location.pathname.includes('/invoice-preview');

  return (
    <>
      {!invoiceView ? (
        <>
          <PagesHeader
            title="Financial"
            hasBackButton={location.pathname.includes('invoice-list')}
            backUrl={'/back-office/invoice/?tab=contracts'}
          />
          <Switch>
            <Route exact path={`${match.path}invoice`}>
              <BackOfficeInvoice />
            </Route>
            <Route
              exact
              path={`${match.path}invoice-list/:contractId`}
              component={(props) => {
                return <BackOfficeInvoiceList {...props} />;
              }}
            />
            <Route
              exact
              path={`${match.path}invoice-list`}
              component={(props) => {
                return <BackOfficeInvoiceList {...props} />;
              }}
            />
            <Route
              exact
              path={`${match.path}invoice-view/:id`}
              component={(props) => {
                return <BackOfficeProformaInvoiceDetails {...props} />;
              }}
            />
          </Switch>
        </>
      ) : null}
      <Route
        exact
        path={`${match.path}invoice-list/product/:productId/invoice-preview/:id`}
      >
        <ContractDownloadInvoice />
      </Route>
    </>
  );
}

export default Profile;
